import React from 'react'
import { constructUrl } from '../../../services/common'
import { icon } from '../../../services/icon'
import { Parser } from '../../common'

const OnlineService = ({ block }) => {
    const renderIcon = (type) => {
        switch (type) {
            case 'Formulaire':
                return icon('form')
            case 'Téléservice':
                return icon('teleservice')
            case 'Outil de recherche':
                return icon('research-tool')
            case 'Simulateur':
                return icon('simulator')
            case 'Modèle de document':
                return icon('document-model')
            default:
                null
        }
    }

    const extractBlock = (block) => {
        const filter = block?.filter(
            (child) => child?.block !== 'Introduction' && child?.block !== 'Source'
        )
        return filter
    }

    return (
        block.childrens &&
        block?.childrens?.map((child, index) => (
            <a
                href={`${constructUrl(child?.attributes?.ID, child?.attributes?.audience)}`}
                className="baseocom-online-service-btn "
            >
                {renderIcon(child?.attributes?.type)}
                <Parser key={index} content_block={extractBlock(child.childrens)} />
            </a>
        ))
    )
}

export default OnlineService
